import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ChipInterface } from 'app/module/chip.interface';

@Injectable({
	providedIn: 'root'
})
export class ChipService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	private httpOptionsFiles = {
		headers: new HttpHeaders({
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E"),
		}),
	}

	constructor(private http: HttpClient) { }

	public findAll(): Observable<ChipInterface[]> {
		return this.http.get<ChipInterface[]>(`${this.url}chip`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public findOne(id: number): Observable<ChipInterface> {
		return this.http.get<ChipInterface>(`${this.url}chip/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public create(data: ChipInterface): Observable<ChipInterface> {
		return this.http
			.post<any>(`${this.url}chip/create`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public importarCsv(formData): Observable<any> {
		return this.http
			.post<any>(`${this.url}chip/importar`, formData, this.httpOptionsFiles)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public importarBips(data): Observable<any> {
		return this.http
			.post<any>(`${this.url}contrato-chip/contrato/entrada-chip`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public update(data: ChipInterface): Observable<ChipInterface> {
		return this.http.put<any>(`${this.url}chip/${data.id_chip}`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// public delete(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }
}
